var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_4108_3182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.63769 11.0913C3.77383 10.5925 3.47704 9.48489 3.97579 8.62103L5.14246 6.60031L4.18262 6.04614L3.01595 8.06687C2.21095 9.46117 2.68922 11.2461 4.08352 12.0511C5.47783 12.8561 7.26276 12.3778 8.06776 10.9835L9.23443 8.96281L8.27459 8.40864L7.10792 10.4294C6.60917 11.2932 5.50155 11.59 4.63769 11.0913ZM6.33871 9.31168L8.67204 5.27023L7.66168 4.6869L5.32834 8.72835L6.33871 9.31168ZM5.93262 3.01505L4.76595 5.03578L5.72579 5.58994L6.89246 3.56922C7.39121 2.70536 8.49883 2.40857 9.36269 2.90732C10.2266 3.40607 10.5233 4.51369 10.0246 5.37755L8.85792 7.39828L9.81776 7.95244L10.9844 5.93172C11.7894 4.53742 11.3112 2.75248 9.91686 1.94748C8.52256 1.14248 6.73762 1.62075 5.93262 3.01505Z",
    fill: "#605D62"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4108_3182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 14) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a2723a3b1de181a07f1de52ac3abcc44.svg";
export { ForwardRef as ReactComponent };